import Vue from 'vue'
import Router from 'vue-router'
import VueProgressiveImage from 'vue-progressive-image'
import Main from '@/components/Main.vue'
import AboutPage from '@/components/AboutPage.vue'
import ContactPage from '@/components/ContactPage.vue'
import PortfolioPage from '@/components/PortfolioPage.vue'
import Portfolio1 from '@/components/Portfolio1.vue'
import Portfolio2 from '@/components/Portfolio2.vue'
import Portfolio3 from '@/components/Portfolio3.vue'
import Portfolio4 from '@/components/Portfolio4.vue'
import Portfolio5 from '@/components/Portfolio5.vue'

Vue.use(Router)
Vue.use(VueProgressiveImage)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
	 },
	 {
      path: '/about',
      name: 'About',
      component: AboutPage
	 },
	 {
      path: '/contact',
      name: 'Contact',
      component: ContactPage
    },
	 {
      path: '/portfolio',
      name: 'Portfolio',
      component: PortfolioPage
    },
	 {
      path: '/portfolio1',
      name: 'Portfolio1',
      component: Portfolio1
    },
	 {
      path: '/portfolio2',
      name: 'Portfolio2',
      component: Portfolio2
    },
	 {
      path: '/portfolio3',
      name: 'Portfolio3',
      component: Portfolio3
	},
	{
	  path: '/portfolio4',
	  name: 'Portfolio4',
	  component: Portfolio4
	},
	{
	  path: '/portfolio5',
	  name: 'Portfolio5',
	  component: Portfolio5
	}
]
})

// this is not working on my web server (cliche)
// ,mode: 'history'
// However now with the new domain on One.com it seems to be required



// WEBPACK FOOTER //
// ./src/router/index.js